const dict = require('general/lang/WidgetEditorPropertyPane.json');
const $t = (prop, def) => {
  if (window.MOBSTEDAPP && window.MOBSTEDAPP.lang) {
    return dict[window.MOBSTEDAPP.lang]['w-a2hs'][prop] || def || prop;
  } else {
    return def || prop;
  }
}

const properties = {
  buttonText: {
    uuid: null,
    componentName: 'ControlInput',
    properties: {
      labelBefore: $t('buttonText', 'Button text'),
      value: '',
    },
    vModelPropertyName: 'value',
  },
};

export default {
  properties,
};
